<template>
    <div class="main" v-if="!loading">

        <c-panel> 
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Instituição</label>
                    <el-select v-model="instituicao" filterable @change="selectIntituicao()">
                        <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>
        
        <template v-if="instituicao">
            <el-form @submit.native.prevent="onSubmit" style="min-height: 270px;" :model="form" ref="form" label-position="top">
                
                <c-panel title="FREQUÊNCIA" titleIcon='fas fa-user'>                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="data *" prop="data" :rules="[$requiredChange]" key="data">
                                <el-select @change="changeForm()" v-model="form.data">
                                    <el-option v-for="(item, i) in dados.datas" :key="i" :label="$moment(item).format('DD/MM/YYYY')" :value="item"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Turma *" prop="turma" :rules="[$requiredChange]" key="turma">
                                <el-select v-model="form.turma" @change="changeForm()">
                                    <el-option v-for="(item, i) in dados.turmas" :key="i" :label="`${item.curso.nome} - ${item.nome}`" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Horário *" prop="horario" :rules="[$requiredChange]" key="horario">
                                <el-select v-model="form.horario" @change="changeForm()">
                                    <el-option v-for="(item, i) in defineHorarios()" :key="i" :label="`${item.nome}`" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
            
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Ação *" prop="acao" :rules="[$requiredChange]" key="acao">
                                <el-select v-model="form.acao" @change="changeAcao">
                                    <el-option key="mover" label="Mover chamada" value="mover"></el-option>
                                    <el-option key="alterar" label="Alterar chamada" value="alterar"></el-option>
                                    <el-option key="excluir" label="Excluir chamada" value="excluir"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel v-if="form.acao == 'mover'" title="FREQUÊNCIA DESTINO" titleIcon='fas fa-user'>                    
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Data *" prop="data" :rules="[$requiredChange]" key="data">
                                <el-select v-model="form.destino.data">
                                    <el-option v-for="(item, i) in dados.datas" :key="i" :label="$moment(item).format('DD/MM/YYYY')" :value="item"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="12">
                            <el-form-item label="Disciplina *" prop="turma" :rules="[$requiredChange]" key="turma">
                                <el-select v-model="form.destino.disciplina">
                                    <el-option v-for="(item, i) in refDisciplinas" :key="i" :label="item" :value="i"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24" :md="24">
                            <el-form-item label="Horário *" prop="horario" :rules="[$requiredChange]" key="horario">
                                <el-select v-model="form.destino.horario">
                                    <el-option v-for="(item, i) in defineHorarios()" :key="i" :label="`${item.nome}`" :value="item.id"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </c-panel>

                <c-panel v-if="form.horario" title="ALUNOS">
                    
                    <el-row :gutter="10">

                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th style="width: 20px;" v-if="form.acao == 'excluir'"></th>
                                    <th>Aluno</th>
                                    <th>Disciplina</th>
                                    <th>Frequência</th>                                
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in form.alunos" :key="i">
                                    <td v-if="form.acao == 'excluir'">
                                        <el-checkbox v-model="form.alunos[i].selecionado"/>
                                    </td>
                                    <td>
                                        {{ item.nome }}
                                    </td>
                                    <td>
                                        <template v-if="form.acao == 'alterar'">
                                            <el-select  @change="disciplinaAlterada(i)" v-model="form.alunos[i].horarios[form.horario].d">
                                                <el-option v-for="(item, i) in refDisciplinas" :key="i" :label="item" :value="i"></el-option>
                                            </el-select>
                                        </template>
                                        <template v-else>
                                            <span v-if="refDisciplinas[form.alunos[i].horarios[form.horario].d]">{{ refDisciplinas[form.alunos[i].horarios[form.horario].d] }}</span>
                                            <span v-else>-</span>
                                        </template>
                                        
                                    </td>
                                    <td>
                                        <template v-if="form.acao == 'alterar'">
                                            <el-select v-model="form.alunos[i].horarios[form.horario].v">
                                                <el-option key="p" label="Presença" value="p"></el-option>
                                                <el-option key="f" label="Falta" value="f"></el-option>
                                                <el-option key="fj" label="Falta justificada" value="fj"></el-option>
                                            </el-select>
                                        </template>
                                        <template v-else>
                                            <span v-if="item.horarios[form.horario].v == 'p'">PRESENÇA</span>
                                            <span v-if="item.horarios[form.horario].v == 'f'">FALTA</span>
                                            <span v-if="item.horarios[form.horario].v == 'fj'">FALTA JUSTIFICADA</span>
                                            <span v-if="!item.horarios[form.horario].v">-</span>
                                        </template>
                                        
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </el-row>
                </c-panel>
                
                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right">
                            <el-button type="primary" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                

            </el-form>
        </template>
    </div>
</template>
<script>

export default {
    data () {
        return {
            instituicao: '',
            loading: false,
            dados: {},
            refDisciplinas: {},
            form: {
                acao: '',
                data: '',
                turma: '',
                horario: '',
                alunos: [],
                destino: {
                    data: '',
                    disciplina: '',
                    horario: ''
                }
            }
        }
    },
    methods:{
        selectIntituicao(){
            if(this.instituicao) {
                this.initFormGerenciarFrequencia();
            }
        },
        async initFormGerenciarFrequencia(){

            this.loading = true;

            let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/frequencia/initFormFrequencia/0/${this.instituicao}`, this.$store.getters.getHeaderAuth);
            
            response.data.datas = response.data.datas.reverse()
            
            this.dados = JSON.parse(JSON.stringify(response.data));

            for(let i in this.dados.disciplinas) {
                this.refDisciplinas[this.dados.disciplinas[i].sigla] = this.dados.disciplinas[i].nome_area
            }
                    
            this.loading = false;
        },
        defineHorarios(){

            let horarios = [];
            for(let i in this.dados.turmas) {                
                if(this.dados.turmas[i].id == this.form.turma) {
                    for(let j = 1; j <= this.dados.turmas[i].qtd_horarios; j++) {
                        horarios.push({id: j, nome: `${j}º horário`});
                    }
                }
            }
            return horarios
        },
        async changeForm(){

            if(!this.form.horario || !this.form.data || !this.dados.turmas) {
                return;
            }

            let paylod = {
                data: this.form.data,
                turma_id: this.form.turma
            }

            let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/aluno/getAlunosByFrequencia`, paylod, this.$store.getters.getHeaderAuth);

            for(let i in response.data) {
                this.$set(response.data[i], 'selecionado', true)
            }
            this.form.alunos = response.data

            this.form.destino.disciplina = this.form.alunos[0].horarios[this.form.horario].d

        },
        changeAcao(){
            this.form.destino.data = ''
            this.form.destino.horario = ''
        },
        onSubmit(){

            this.$refs.form.validate( async (valid) => { if(valid){

                window.eventBus.$emit('loading', true);

                let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/frequencia/storeGerenciarFrequencia`, this.form, this.$store.getters.getHeaderAuth);

                if(typeof response.data.error !== 'undefined'){

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: response.data.error, type: 'warning'});

                }else{

                    window.eventBus.$emit('loading', false);
                    window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                    this.form = {
                        acao: '',
                        data: '',
                        turma: '',
                        horario: '',
                        alunos: [],
                        destino: {
                            data: '',
                            disciplina: '',
                            horario: ''
                        }
                    };  
                }

            }else{ window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'}); }});
        },
        disciplinaAlterada(i){

            let disciplinaSelecionada = this.form.alunos[i].horarios[this.form.horario].d;
           
            for(let j in this.form.alunos) {

                if(this.form.alunos[j].horarios[this.form.horario].d) { 
                    this.form.alunos[j].horarios[this.form.horario].d = disciplinaSelecionada;
                }
            }
        }
    }    
}
</script>
<style>

    .titulo-list-alunos {
        background-color: #ccc; padding: 5px 10px;
    }

    .list-alunos-usuario{
        margin: 10px 0px;
    }

    .list-alunos-usuario .checkbox-list{
        margin-left: 20px;
    }

    .list-alunos-usuario ul {
        padding: 0;
        height: 700px;
        overflow: auto;
    }

    .list-alunos-usuario li {
        padding: 5px 0;
        border-bottom: 1px solid #ccc;
    }

    .list-alunos-usuario{
        border: 1px solid #ccc;
    }

</style>